import { doPrintRefundToPdf } from '../../../api/refundService';
import DataTableActions from '../../../components/Monetize/DataTable/MDataTableActions';
import { downloadAndSaveToPDF } from '../../../utils';

interface RefundActionsProps {
  refundId?: string;
}

export const RefundActions = ({ refundId }: RefundActionsProps) => {
  const actions = [
    {
      title: 'Print to PDF',
      enabled: true,
      action: () => downloadAndSaveToPDF(() => doPrintRefundToPdf(refundId!)),
    },
  ];

  if (!refundId) {
    return null;
  }

  return <DataTableActions actions={actions} />;
};
